var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseMidHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_close_mid_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.167367554,0.167367554 C0.390524292,-0.0557891845 0.752332851,-0.0557891845 0.975489589,0.167367554 L0.975489589,0.167367554 L4,3.192 L7.02451041,0.167367554 C7.22287196,-0.0309939914 7.53078556,-0.0530341631 7.753492,0.101247039 L7.83263245,0.167367554 C8.05578918,0.390524292 8.05578918,0.752332851 7.83263245,0.975489589 L7.83263245,0.975489589 L4.808,4 L7.83263245,7.02451041 C8.03099399,7.22287196 8.05303416,7.53078556 7.89875296,7.753492 L7.83263245,7.83263245 C7.60947571,8.05578918 7.24766715,8.05578918 7.02451041,7.83263245 L7.02451041,7.83263245 L4,4.808 L0.975489589,7.83263245 C0.777128044,8.03099399 0.469214443,8.05303416 0.246507997,7.89875296 L0.167367554,7.83263245 C-0.0557891845,7.60947571 -0.0557891845,7.24766715 0.167367554,7.02451041 L0.167367554,7.02451041 L3.192,4 L0.167367554,0.975489589 C-0.0309939914,0.777128044 -0.0530341631,0.469214443 0.101247039,0.246507997 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_close_mid_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape-Copy-2",
    fill: "#B1B1B1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMidHover);
export default __webpack_public_path__ + "static/media/icon_close_mid_hover.a8b97715172c37d54e1d71311626adec.svg";
export { ForwardRef as ReactComponent };